<div class="bk-dialog">

    <button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

    <h4 *ngIf="isEditMode" mat-dialog-title>
		{{ 'Edit' | translate }} {{ 'System Label' | translate }}
	</h4>

	<h4 *ngIf="!isEditMode" mat-dialog-title>
		{{ 'Create' | translate }} {{ 'System Label' | translate }}
	</h4>

    <div *ngIf="form"
		mat-dialog-content>

		<form [formGroup]=form>
			<mat-form-field appearance="fill"
				class="mat-form-field--full-width">

				<mat-label>
					{{'Keyword' | translate }}
				</mat-label>

				<input matInput
					required
					type="text"
					formControlName="Keyword"/>

			</mat-form-field>
			
			<div *ngFor="let languageCode of languageCodes; let i = index">
				<mat-form-field appearance="fill"
					class="mat-form-field--full-width">

					<mat-label>
						{{ languageCode.Language }}
					</mat-label>

					<textarea matInput
						rows="3"
						type="text"
						[formControl]="f.LocalizedDictionaries.at(i).get('Word')">
					</textarea>

				</mat-form-field>
			</div>
		</form>
    </div>

    <div mat-dialog-actions align="end">

        <button mat-button
            class="bk-button bk-button--medium bk-button--text-only
            bk-dialog__button--secondary"
            (click)="close()">
            {{ 'Cancel' | translate }}
        </button>

        <button *ngIf="!isEditMode"
            mat-button 
            class="bk-button bk-button--medium"
            (click)="save()">
            {{ 'Create' | translate }}
        </button>

        <button *ngIf="isEditMode"
            mat-button 
            class="bk-button bk-button--medium"
            (click)="save()">
            {{ 'Save' | translate }}
        </button>
    </div>
</div>
